import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';

@Component({
  selector    : 'template-demand',
  templateUrl : './template-demand.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplateDemand {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false
}
